import { render, staticRenderFns } from "./ToeflPrimaryStep2ScoreComponent.vue?vue&type=template&id=432034b4&scoped=true&"
import script from "./ToeflPrimaryStep2ScoreComponent.vue?vue&type=script&lang=js&"
export * from "./ToeflPrimaryStep2ScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToeflPrimaryStep2ScoreComponent.vue?vue&type=style&index=0&id=432034b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432034b4",
  null
  
)

export default component.exports